import { render } from "./ScriptPrePrintDetailed.vue?vue&type=template&id=30901ba2&scoped=true"
import script from "./ScriptPrePrintDetailed.vue?vue&type=script&lang=js"
export * from "./ScriptPrePrintDetailed.vue?vue&type=script&lang=js"

import "./ScriptPrePrintDetailed.vue?vue&type=style&index=0&id=30901ba2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30901ba2"]])

export default __exports__